const listAttributes = ['subject', 'label', 'shortLabel', 'category', 'topics'] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['label', 'shortLabel', 'topics'] as const;

const updateTopicAttributes = ['label', 'shortLabel', 'resources', 'videos'] as const;

export const VideoCategoryAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  UpdateTopic: updateTopicAttributes,
};
